import React from 'react';

export default function Metric({title, subTitle, number, unit, icon, variant, onClick}) {
    return (
        <div className={'metric card ' + variant}
             onClick={onClick}
        >
            <div className="card-body">
                <h5 className="card-title d-flex justify-content-center">
                    <div className="metric-icon">
                        {icon}
                    </div>
                    <div>
                        {title}
                        {subTitle && <small className="d-block">{subTitle}</small>}
                    </div>
                </h5>
                <div className="metric-number">
                    {number}{unit && <span className="metric-unit">{unit}</span>}
                </div>
            </div>
        </div>
    );
}
